import BigPicture from "bigpicture";

document.addEventListener("DOMContentLoaded", function (event) {

    var button = document.querySelector('[data-behaviour="menubutton"]');
    button.addEventListener("click", function (event) {
        document.body.classList.toggle("body--showmenu");
    })

    //Video Popup
    let videoElement = document.querySelector('[data-behaviour="video"]');

    if(videoElement) {
        videoElement.addEventListener("click", (e) => {
            e.preventDefault();
            const videoUrl = videoElement.getAttribute('data-url');
            BigPicture({
                el: e.target,
                iframeSrc: videoUrl,
            })
        })
    }

    //Show hide
    let showHideElements = [...document.querySelectorAll('[data-behaviour="showhide"]')];

    showHideElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            element.parentNode.classList.toggle("showhide--selected")

            showHideElements.filter(e => e != element).forEach((e) => e.parentNode.classList.remove("showhide--selected"));
        })
    });

    const groupElements = [...document.querySelectorAll('.group')]

    const groups = groupElements.map((element) => {
        const data = JSON.parse(element.getAttribute("data-searchdata"));
        data["element"] = element;
        return data;
    });

    let searchInput = document.querySelector('[data-behaviour="searchtext"]');
    let topicSelect = document.querySelector('[data-behaviour="searchtopic"]');

    const filterGroups = (e) => {
        e.preventDefault();
        const q = searchInput.value.toLowerCase();
        const topic = parseInt(topicSelect.value);

        if(q || topic) {
            groups.forEach((group) => {
                group.element.classList.add("group--hide");
            })

            let selected = groups;
            if(q) {
                selected = selected.filter(group => group.SearchText.includes(q));
            }
            if(topic) {
                selected = selected.filter(group => group.Topics.includes(topic));
            }

            selected.forEach((group) => {
                group.element.classList.remove("group--hide");
            })

        }
    }

    if(searchInput) {
        searchInput.addEventListener("keyup", filterGroups);
        topicSelect.addEventListener("change", filterGroups);
    };

});
